import { Sha256 } from '@aws-crypto/sha256-js'

export type OpenAiCustomer = {
  email?: string | null
  externalId?: string | null
  phone?: string | null
  firstName?: string | null
  lastName?: string | null
}

export type OpenAiUserData = Partial<
  Record<
    | 'email_sha256'
    | 'external_id_sha256'
    | 'phone_number_sha256'
    | 'first_name_sha256'
    | 'last_name_sha256',
    string
  >
>

// The SDK expects normalized SHA-256 digests, never raw identifiers.
export function hashOpenAiCustomer(customer: OpenAiCustomer): OpenAiUserData {
  const name = (value?: string | null) =>
    value?.toLowerCase().replace(/[\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g, '')
  // Match the backend's E.164 digits, which default national numbers to GB.
  const digits = customer.phone?.replace('(0)', '').replace(/[\s().-]/g, '')
  const phone = digits?.startsWith('+')
    ? digits.slice(1)
    : digits?.startsWith('00')
    ? digits.slice(2)
    : digits?.replace(/^0/, '44')
  const fields: [keyof OpenAiUserData, string | undefined][] = [
    ['email_sha256', customer.email?.trim().toLowerCase()],
    ['external_id_sha256', customer.externalId?.trim()],
    [
      'phone_number_sha256',
      phone && /^\d{8,15}$/.test(phone) ? phone : undefined
    ],
    ['first_name_sha256', name(customer.firstName)],
    ['last_name_sha256', name(customer.lastName)]
  ]
  const result: OpenAiUserData = {}
  fields.forEach(([key, value]) => {
    if (!value) return
    const hash = new Sha256()
    hash.update(value)
    result[key] = Array.from(hash.digestSync(), byte =>
      byte.toString(16).padStart(2, '0')
    ).join('')
  })
  return result
}
